<style lang="less">
  @mw-green: #86BD60;

  td{
    font-size: 0.70em !important;
  }

  td.text-start:nth-child(1){
    .mdi-checkbox-blank-outline, .mdi-checkbox-marked{
      padding-left: 15px;
    }
  }
  // tbody {
  //   tr.v-data-table__mobile-row {
  //     &:nth-child(odd){
  //       td{
  //         background: #efefef !important;
  //       }
  //     }
  //   }
  // }
  .mwTableCell{
    height: 100%;
    width: 100%;
    padding: 4px 0px;
    cursor: pointer;
    &:hover{
      background: lighten( @mw-green, 20% );
    }
    &.focus{
      background: @mw-green;
    }
    &.highlighted{
      background: lighten( @mw-green, 20% );
    }
  }
  #segmentTable td.text-start{
    padding: 0px 5px !important;
  }


</style>

<template>
  <v-row>
    <v-col>
      <v-text-field
        v-model="search"
        v-if="showSearch"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <p class="text-right">
        <v-btn color="primary" @click="toggleMobileView"><v-icon>mdi-format-rotate-90</v-icon>Rotate</v-btn>     
      </p>
      <v-data-table
      :items-per-page="20"
      class="elevation-1"
      :id="id"
      :headers="columns"
      :items="rows"
      :item-key="itemKey"
      :search="search"
      :show-select="showSelect"
      v-model="selected2"
      :multi-sort="true"
      :mobileBreakpoint="mobileBreakpoint">
      <template v-for="column in columns" v-slot:[`item.${column.value}`]="{ item }">
        <div 
        v-if="(editable && column.inline) || column.inline == 'always'"
        class="mwTableCell text-center" 
        :row="item.id" 
        :column="column.value" 
        :key="item.id+'-'+column.value" 
        :cellKey="item.id+'-'+column.value" 
        :cellValue="item[column.value]" 
        :class="{'focus': allowHighlight && focus == item.id+'-'+column.value, 'highlighted': allowHighlight && focusArray.indexOf(item.id+'-'+column.value) > -1 }"
        @click="startFocus(item,column)"
        >  
          <EditableTableField :item="item" :column="column" v-on:save="save"></EditableTableField>
        </div>
        <div class="pa-2" v-else :key="item.id+'-'+column.value">
          <div v-if="column.type == 'button'">
            <v-btn :color="column.color" @click="$emit(column.value, item)" dark>{{column.text}}</v-btn>
          </div>
          <div v-else>
            <UneditableTableField :item="item" :column="column"></UneditableTableField>
          </div>
        </div>
      </template>    

      </v-data-table>
      <div v-if="allowExport" class="mt-2">
        <export-excel
          :data="exportRows"
          :fields="exportColumns"
          :name="exportName">
          <v-btn color="accent">Download</v-btn>
        </export-excel>
      </div>  
      <v-snackbar v-model="copied" light>
        Copied<v-btn color="green" text @click="copied = false">Close</v-btn>
      </v-snackbar>
    </v-col>
  </v-row>
</template>
<script>
import Vue from "vue";
import excel from 'vue-excel-export'
Vue.use(excel)
import UneditableTableField from "../tools/UneditableTableField"
import EditableTableField from "../tools/EditableTableField"

export default {
  name: 'MwDataTable',
  components: {
    UneditableTableField: UneditableTableField,
    EditableTableField: EditableTableField
  },
  props: {
    id:  { type: String, default: () => "MwDataTable"  },
    allowHighlight:  { type: Boolean, default: true },
    editable:  { type: Boolean, default: false },
    allowExport:  { type: Boolean, default: false },
    exportName: { type: String },
    showSelect: { type: Boolean, default: false },
    showSearch: { type: Boolean, default: true },
    itemKey: { type: String },
    columns: { type: Array }, 
    rows: { type: Array, default: () => [] },
  },
  data: () => {
    return {
      mobileBreakpoint: 650,
      focus: false,
      focusArray: [],
      x: 0, 
      y: 0,
      copied: false,
      copyValue: false, 
      search: '',
      selected2: []
    }
  },
  computed:{
    exportColumns: function(){
      let columnObject = {}
      this.columns.filter( column => column.type !== 'button').forEach( column => columnObject[column.text] = column.value )
      return columnObject;
    },
    exportRows: function(){
      return this.rows;
    }
  },
  watch: {
    editable(){
      this.focus = false;
    }, 
    copyValue(v){
      if( v ){ 
        this.copied = true;
      }
    },
    selected2(selected){
      this.$emit('change',  selected );
    }
  },
  mounted: function() {
    const self = this;
    document.addEventListener( "keydown", function(event){
      if( self.focus ){
        if( event.code == "Escape" ){
          self.focusArray = [];
          self.copyValue = false;
          self.copied = false;
          self.focus = false;
        }
        if( event.ctrlKey ){
          if( event.code == "KeyC" ){
            self.copyValue = self.getValueByKey(self.focus);
          }
        }
        if( event.ctrlKey ){
          if( event.code == "KeyV" ){
            if( self.focusArray.length ){
              self.focusArray.forEach( key => {
                self.setValueByKey(key, self.copyValue);
              })
            }
            self.setValueByKey(self.focus, self.copyValue);
            
          }
        }
        if( event.key == 'ArrowUp' || event.key == 'ArrowDown' || event.key == 'ArrowLeft' || event.key == 'ArrowRight'){
          event.preventDefault();
          let x = self.x;
          let y = self.y;
          if( event.key == 'ArrowUp' ){  y--; }
          if( event.key == 'ArrowDown' ){  y++;  }
          if( event.key == 'ArrowLeft' ){  x--;  }
          if( event.key == 'ArrowRight' ){ x++; }
          if( event.ctrlKey ){
            self.focusArray.push( self.focus )
          }
          else{
            self.focusArray = [];
          }
          self.changeFocus(x, y);
        }
      }
    })
  },
  methods: { 
    startFocus(item, header){
      this.focusArray = [];
      this.focus = item.id+'-'+header.value;
      let column = event.target.parentNode;
      let row = event.target.parentNode.parentNode;
      let rows = Array.prototype.slice.call( row.parentNode.children )
      this.y = rows.indexOf(row);
      this.x = Array.prototype.slice.call( row.children ).indexOf(column);
    },
    changeFocus(x, y){
      // @BECCA - you have done this in this roundabout way because the index of the row is not available
      // when iterating through the item.{name} slot
      // if the index of the row was available:
      // focus = boolean
      // class: {'focus': x == rowIndex && y == columnIndex }
      // then changing the focus using arrow keys can just be a case of changing relevant x and y
      // rather than having to base the focus on the value / id of the cell 
      // you can't just look up the index because the order of the rows can be sorted and columns can be hidden. 

      const self = this;
      if( 
        x == -1 || 
        y == -1 || 
        y > (self.rows.length -1 ) || 
        x > (self.columns.length -1 )
      ){
        return;
      }
      let tbody = document.getElementById( self.id  ).getElementsByTagName("tbody").item(0)
      let rows = Array.prototype.slice.call( tbody.children );
      let row = rows[y];
      let cell = Array.prototype.slice.call( row.children )[x];
      let cellKey = cell.getElementsByTagName("div").item(0).getAttribute("cellKey")
      this.focus = cellKey;
      self.x = x;
      self.y = y;
    },
    getValueByKey(key){
      let cell = document.querySelectorAll(`[cellKey="${key}"]`)[0];
      return cell.getAttribute("cellValue");
    },
    setValueByKey(key,value){
      let cell = document.querySelectorAll(`[cellKey="${key}"]`)[0];
      let column = cell.getAttribute("column");
      let row = cell.getAttribute("row");
      let item = this.rows.find( r => r.id == row );
      let header = this.columns.find( c => c.value == column );
      item[column] = value;
      this.save(item, column, header.saveDataType)
    },
    getCellContent(item, column){
      return item[column.value];
    },
    toggleMobileView(){
      if( this.mobileBreakpoint == 650 ){
        this.mobileBreakpoint = window.screen.width+50;
      }
      else{
        this.mobileBreakpoint = 650;
      }
    },
    save(item, column, saveDataType){
      this.$emit( "update", item, column, saveDataType )
    }

  },
};
 
</script>